import { Component, Mixins } from "vue-property-decorator";
import PrecheckAlertMixin from "@/mixins/precheckAlertMixin";
import PrecheckLeaveAlertDialog from "@/components/receipt/PrecheckLeaveAlertDialog.vue";
import {
  registerPrecheckLeaveAlertHandler,
  unregisterPrecheckLeaveAlertHandler
} from "@/main";

/**
 * ヘッダーナビゲーション（マイページ・事業所変更・ログアウト）からの
 * 離脱時にアラートBを表示するためのハンドラ登録を共通化するミックスイン。
 *
 * 利用側は以下を実装すること:
 *   - @Ref("precheckLeaveAlertDialog") protected readonly precheckLeaveAlertDialog!: PrecheckLeaveAlertDialog
 *   - protected async shouldShowPrecheckLeaveAlert(): Promise<boolean>
 */
@Component
export default class PrecheckLeaveAlertMixin extends Mixins(
  PrecheckAlertMixin
) {
  protected precheckLeaveAlertDialog!: PrecheckLeaveAlertDialog;

  protected async shouldShowPrecheckLeaveAlert(): Promise<boolean> {
    return false;
  }

  mounted() {
    registerPrecheckLeaveAlertHandler(async () => {
      if (!(await this.shouldShowPrecheckLeaveAlert())) return true;
      const result = await this.precheckLeaveAlertDialog.open();
      if (result.suppressToday) {
        await this.savePrecheckAlertSuppress();
      }
      return result.ok;
    });
  }

  beforeDestroy() {
    unregisterPrecheckLeaveAlertHandler();
  }
}
